import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { useDispatch, useSelector } from 'react-redux';
import { baseApi } from './baseApi';
import authReducer from './Slices/authSlice';
import uiReducer from './Slices/uiSlice';
import syncReducer from './Slices/syncSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    // §28 — the outbox's pending count and dead letter, so the SyncBanner can
    // say what has not reached the server yet.
    sync: syncReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefault) => getDefault({ serializableCheck: false }).concat(baseApi.middleware),
});

// Enables `refetchOnReconnect` — the one automatic refetch worth having on a
// weak link, because coming back online is exactly when the cache is stalest.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
